import { UserTypes } from './constants'

export const getBooleanUserRolesByUser = (user) => {
  const userRoles = user?.roles

  const PERSONNEL = !!userRoles?.includes(UserTypes.PERSONNEL)
  const B2B_PERSONNEL = !!userRoles?.includes(UserTypes.B2B_PERSONNEL)
  const B2B_USER = !!userRoles?.includes(UserTypes.B2B_USER)
  const USER = !!userRoles?.includes(UserTypes.USER)
  const ADMIN = !!userRoles?.includes(UserTypes.ADMIN)
  const PERSONNEL_USERS = !!userRoles?.includes(UserTypes.PERSONNEL_USERS)
  const PERSONNEL_PACKAGES = !!userRoles?.includes(UserTypes.PERSONNEL_PACKAGES)
  const ANONYMOUS = !!userRoles?.includes(UserTypes.ANONYMOUS)

  return {
    B2B_PERSONNEL,
    B2B_USER,
    USER,
    ADMIN,
    ANONYMOUS,
    PERSONNEL_USERS,
    PERSONNEL_PACKAGES,
    // imaginal types:
    ADMIN_PERSONNEL_USERS: ADMIN || PERSONNEL_USERS,
    ADMIN_PERSONNEL_PACKAGES: ADMIN || PERSONNEL_PACKAGES,
    PERSONNEL: PERSONNEL || ADMIN,
    B2B: B2B_PERSONNEL || B2B_USER,
    B2B_ONLY: (B2B_PERSONNEL || B2B_USER) && (!USER && !ADMIN && !ANONYMOUS)
  }
}

export const isThreadIncoming = (emailArr) => {
  return emailArr?.[0]?.type === 'INCOMING'
}

export const getInitials = (name) => {
  if (!name) return '?'

  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return '?'

  const firstInitial = words[0][0] || ''
  const lastInitial = words.length > 1
    ? words[words.length - 1][0]
    : ''

  return (firstInitial + lastInitial).toUpperCase()
}

export const extractHtmlContent = (htmlString) => {
  if (!htmlString || htmlString === 'null') return null

  return new DOMParser().parseFromString(htmlString,
    'text/html').documentElement.textContent
}

export const getRelevancyLevelInfo = (relevancyLevel) => {
  const levels = {
    HIGHLY_SUITABLE: {
      level: 1,
      color: '#1B5E20',
      labelKey: 'mailTemplate.relevancyLevel.highlyRelevant'
    },
    MODERATELY_SUITABLE: {
      level: 2,
      color: '#388E3C',
      labelKey: 'mailTemplate.relevancyLevel.moderatelyRelevant'
    },
    MINIMALLY_SUITABLE: {
      level: 3,
      color: '#8BC34A',
      labelKey: 'mailTemplate.relevancyLevel.minimallyRelevant'
    },
    NOT_SUITABLE: {
      level: 'X',
      color: '#F44336',
      labelKey: 'mailTemplate.relevancyLevel.notRelevant'
    },
    CANNOT_ACCESS: {
      level: 'X',
      color: '#660101',
      labelKey: 'mailTemplate.relevancyLevel.cannotAccess'
    }
  }

  return levels[relevancyLevel] || null
}
